import React from 'react';
import { Container, Row } from 'reactstrap';
import { withNamespaces } from 'react-i18next';

export default withNamespaces()(Footer);
function Footer(props) {
  const { t } = props;
  return (
    <div style={{ backgroundColor: '#1E3642' }}>
      <Container>
        <Row
          className={'justify-content-center align-items-center'}
          style={{ height: 40 }}
        >
          <div style={{ color: 'white', fontSize: 14 }}>
            {t('footer.description')}
          </div>
        </Row>
      </Container>
    </div>
  );
};
